import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';

import api from '@/api';
import Checkout from '../../classes/Checkout';

export default {
    extends: api,
    props: ['terms','callSunday'],
    data() {
        return {
            showCheckoutStepOne: true,
            loading: true,
            showCalendar: false,
            showPaymentsForm: false,
            checkedConditions: false,
            stepOneKey: 0,
            paymentMethodId: 1,
            paymentMethod: null,
            showFormsPayments: false,
            stripeKey: 0,
            resumeKey: 0
        }
    },
    created() {
        window.onbeforeunload = function () {
            return '';
        };
        window.visibilitychange = function () {
            return '';
        };

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                location.reload();
            }
        });

    },
    computed: {
        ...mapGetters(['getDateSelected','getCheckout','getExperiences','getDesign','getToken', 'getItemsExperience','getPlayersSelected']),
        roomHour: function () {
            return (room) => {
                if(!room) return '';
                let startHour = room.startHour;
                if(!startHour){
                    const date = new Date(room.start);
                    const hour = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    startHour = `${hour}:${minutes}`;
                }
                return startHour;
            }
        },
        totalPeople: function () {
            let people = 0;
            this.getCheckout().items.forEach((item) => { people += item.people_number });
            return people;
        },
        getTotalPriceCalcutate: function () {
            let total = 0;
            const checkout = this.getCheckout();
            checkout.items.forEach((item) => {
                total += Number(item.price_original);
                item.fields.forEach((field) => {
                    if (field.name.includes('*')) {
                        total += field.amount * item.people_number;
                    } else if (!field.name.includes('=')) {
                        total += field.amount;
                    }
                });
            });

            const filedsPerReservation = checkout.items.map(i => i.fields).flat().filter(x => x.name.includes("+="));
            // Los campos que se cobran por reserva solo se deneben de cobrar una vez pero la estrucutra de datos pone varios por cada item
            const extraPerReservation = this.unique(filedsPerReservation).reduce((total, item) => total + item.amount, 0);

            if (extraPerReservation) {
                // Se multiplica por el numero de elemtos porque el backend fuerza a que se le mande repartidos los items por reserva
                total += (extraPerReservation * checkout.items.length);
            }

            return parseFloat(total).toFixed(2);
          
        },
    },
    methods: {
        ...mapMutations(['updateIdPurchase','updateCheckout','refreshState','updateCheckoutField']),
        handleCreatePurchase: function (event) {
          const isChecked = event.target.checked;

          if(isChecked) {
            this.createNewPurchase();
          }else {
            this.cancelPurchase();
          }
        },
        createNewPurchase: function () {            
            let createPurchasePrommise = new Promise((resolve) => {
                this.createPurchaseApi(resolve);
            });
            createPurchasePrommise.then((purchase) => {
                this.loading = true;
                this.resumeKey++;
                this.updateIdPurchase({idPurchase: purchase.id});
                this.updateCheckout({checkout: purchase});
            });
        },
        cancelPurchase: function () {
            if (this.getCheckout().id) {
              new Promise((resolve) => this.cancelPurchaseApi(resolve));
            }
          },
        changePaymentMethod: function (value) {
            this.paymentMethod = value.payment;
            this.paymentMethodId = value.paymentMethodId
        },
        nextStep: function () {
            const requiredFields = Array.from(document.getElementsByClassName("required-field"));

            let isValid = true;
            let isValidatedField = false;

            requiredFields.forEach(field => {
                isValid = !!field.value.trim();

                if(field.type === 'email'){
                    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    isValid = regex.test(field.value);

                    if(isValid){
                        field.nextElementSibling.classList.remove('show');
                    }else{
                        field.nextElementSibling.classList.add('show')
                    }
                }

                if(!isValid){
                    field.classList.add('input-error');

                    if(!isValidatedField){
                        field.scrollIntoView();
                        isValidatedField = true;
                    }
                }
            });
            if (isValid) {
                this.showCheckoutStepOne = false;
            }
        },
        backButton: function () {
            if(this.showCheckoutStepOne){
                const checkout = this.getCheckout();
                checkout.mail = '';
                checkout.name = '';
                checkout.dni = '';
                checkout.phone = ''; 

                if(checkout.id) {
                    // Es importante cancelar antes de borrar
                    new Promise(resolve => this.cancelPurchaseApi(resolve));
                    // Se borra el id para evitar que se haga patch
                    let newCheckout = new Checkout();
                    checkout.id = null;
                    checkout.status = newCheckout.status;
                    checkout.mail_status = newCheckout.mail_status;
                    checkout.interna_permanent = newCheckout.interna_permanent;
                    checkout.id_discount = newCheckout.id_discount;
                    checkout.id_bono = newCheckout.id_bono;
                    checkout.price_final = newCheckout.price_final;
                    checkout.price_final = newCheckout.price_final;
                    checkout.id_bono = newCheckout.id_bono;
                    checkout.price_fractioned = newCheckout.price_fractioned;
                    checkout.is_fractioned = newCheckout.is_fractioned;
                    checkout.code = newCheckout.code;
                    // No elminar items porque lo necesita minimal para ir atras
                }
              
                this.updateCheckout({checkout})
                this.$emit('back-step');
            } else{
                this.showCheckoutStepOne = true;
            }
        },
        checkForm: function (e) {

            e.preventDefault();

            if(this.getCheckout().id) {
                this.showFormsPayments = true;

                if (this.paymentMethod.url) {
                    window.location.href = this.paymentMethod.url;

                    this.saveLocalStoragePayment();
                }
                else if (this.paymentMethod.form && this.paymentMethodId !== 3) {
                    setTimeout(() => {
                        let form = document.getElementById('final-form');
                        form.action = this.paymentMethod.form.action;
                        form.method = 'post';
                        for (let [key, value] of Object.entries(this.paymentMethod.form)) {
                            if (key !== 'action') {
                                form.innerHTML += '<input name="' + key + '" value="' + value + '" />';
                            }
                        }
                        this.saveLocalStoragePayment();
                        form.submit();
                    }, 500);
                }
                else {
                    this.stripeKey++;
                }
            }
        },
        saveLocalStoragePayment: function () {
            localStorage.setItem('toPayment', this.getCheckout().id);
            localStorage.setItem('token', this.getToken());
        },
        unique: function (fields) {
            let uniques = new Map();

            for (let i = 0; i < fields.length; i++) {
                let field = fields[i];
                let key = `${field.name}-${field.title}-${field.total}-${field.value}`;
                if (!uniques.has(key)) {
                  uniques.set(key, field);
                }
                
            }

            return Array.from(uniques.values());
        }
    }
}